import { Button, Dialog, DialogClose } from "@wilco/ui";
import { t } from "./i18n.ts";

export interface Confirm {
  title: string;
  body: string;
  action: string;
  run: () => void;
}

/**
 * Переспрос перед действием, которое сервер просит подтвердить кодом
 * правила (больше ожидаемого, без замовлення, незакрытый маршрут).
 */
export function ConfirmDialog({ confirm, onClose }: { confirm: Confirm | null; onClose: () => void }) {
  return (
    <Dialog
      open={confirm !== null}
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
      title={confirm?.title ?? ""}
      description={confirm?.body}
      footer={
        <>
          <Button
            variant="primary"
            onClick={() => {
              const run = confirm?.run;
              onClose();
              run?.();
            }}
          >
            {confirm?.action}
          </Button>
          <DialogClose asChild>
            <Button variant="ghost">{t("common.cancel")}</Button>
          </DialogClose>
        </>
      }
    />
  );
}
